import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import {LogIn} from './Components/LogIn/LogIn';
import {MainPage} from './Components/MainPage/MainPage';
import {PatientPage} from './Components/PatientPage/PatientPage';
import {PrescriptionPage} from './Components/Prescriptions/Prescriptions';
import {ReferralPage} from './Components/Referrals/Referral';
import { UserTimeTracker } from './analytics';


//import the Context ("database") in all the app
import {DataProvider1, DataProvider3, DataProvider4, DataProvider6, DataProvider9, DataProvider10} from './Context'
require('dotenv').config()



function RouteTracker() {
  const location = useLocation();
  
  useEffect(() => {
    // Καταγραφή της νέας σελίδας
    UserTimeTracker.trackPageView(location.pathname);
    
    // Όταν φεύγουμε από τη σελίδα
    return () => {
      UserTimeTracker.trackPageExit(location.pathname);
    };
  }, [location.pathname]);
  
  return null;
}




function App() {
   
  //Check connection, browser arrows, inert time
  useEffect(() => {

    
    //Prevent "Back" in browser
    const handlePopState = () => {
        window.location.href = "/"
        alert('Η χρήση του κουμπιού "Πίσω" του φυλλομετρητή ενδέχεται να δημιουργήσει προβλήματα στην διαδικασία της συνταγογράφησης. Για τον λόγο αυτό θα γίνει επαναφόρτωση της εφαρμογης. Επιλέξτε "ΟΚ" για να συνεχίσετε');
    }
 
   

   
    



    window.addEventListener('popstate', handlePopState)
  
    return () => {
      window.removeEventListener('popstate', handlePopState)
    }



  }, []);
  
  //Google analytics
  useEffect(() => {
    // Εκκίνηση παρακολούθησης όταν φορτώνει η εφαρμογή
    UserTimeTracker.startSession();
    
    // Καταγραφή τέλους συνεδρίας όταν κλείνει η εφαρμογή
    const handleBeforeUnload = () => {
      UserTimeTracker.endSession();
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      UserTimeTracker.endSession();
    };
  }, []);

  return (
    <Router>
      <RouteTracker/>
      <Routes>
        <Route path="/" exact element={<LogIn />} />
        <Route path="/MainPage" exact element={<MainPage />} />
        <Route path="/PatientPage" exact element={<PatientPage />} />
        <Route path="/PrescriptionPage" exact element={<PrescriptionPage />} />
        <Route path="/ReferralPage" exact element={<ReferralPage />} />
      </Routes>
    </Router>
  )
}


ReactDOM.createRoot(document.getElementById("root")).render(
  <DataProvider1>
    <DataProvider3>
      <DataProvider4>
        <DataProvider6>
          <DataProvider9>
            <DataProvider10>
              <App/>
            </DataProvider10>
          </DataProvider9>
        </DataProvider6>
      </DataProvider4>
    </DataProvider3>
  </DataProvider1>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
